import { useNavigate } from "react-router-dom";
import { useExpenses } from "../hooks";
import ExpenseCard from "../components/ExpenseCard/ExpenseCard.jsx";
import Loading from "../../../conponents/loading/Loading";
import EmptyState from "../../../conponents/emptyState/index";
import FloatingActionButton from "../../../conponents/floatingActionButton/FloatingActionButton";
import styles from "./ExpenseList.module.css";
import useInfiniteScroll from "../../../hooks/useInfiniteScroll.js";
import ReceiptDialog from "../components/dialog/ReceiptDialog.jsx";
import notify from "../../../services/notify";
import { useState } from "react";
import ConfirmDialog from "../../../conponents/confirmDialog";
import expenseService from "../services/expenseService";
import ExpenseFilterBar from "../components/ExpenseFilterBar/ExpenseFilterBar";
import { selectCars } from "../../../redux/car/car-slice";
import { useSelector } from "react-redux";
import useExpenseCategories from "../hooks/useExpenseCategories";
import ExpenseSummaryBar from "../components/ExpenseSummaryBar/ExpenseSummaryBar";

const ExpenseList = () => {

    const cars = useSelector(selectCars);

    const { categories } = useExpenseCategories();

    const navigate = useNavigate();

    const [

        selectedExpense,
    
        setSelectedExpense,
    
    ] = useState(null);
    
    const [
    
        deleteDialogOpen,
    
        setDeleteDialogOpen,
    
    ] = useState(false);

    const [

        receiptImage,
    
        setReceiptImage,
    
    ] = useState(null);

    const [deleting, setDeleting] = useState(false);

    const {

        expenses,
    
        loading,
    
        loadingMore,
    
        hasMore,
    
        loadMore,
    
        refresh,

        error,

        filters,

        updateFilters,
    
        search,
    
        setSearch,

        summary,
    
    } = useExpenses();

    const activeFilterCount = [

        filters.carId,
    
        filters.categoryId,
    
        filters.fromDate,
    
        filters.toDate,
    
        search,
    
    ].filter(value =>
    
        value !== "" &&
    
        value !== null &&
    
        value !== undefined
    
    ).length;

    const loadMoreRef = useInfiniteScroll({

        enabled: true,
    
        loading: loadingMore,
    
        hasMore,
    
        onLoadMore: loadMore,
    
    });

    const handleAddExpense = () => {

        navigate("/add-expense");

    };

    const handleOpenExpense = (expense) => {

        navigate(`/expenses/${expense.id}`);

    };

    const [

        receipt,
    
        setReceipt,
    
    ] = useState(null);
    

    const handleReceipt = (expense) => {

        if (!expense.hasImage) {
    
            notify.info(
    
                "برای این هزینه فاکتوری ثبت نشده است."
    
            );
    
            return;
    
        }
    
        setReceiptImage(
    
            expense.imageUrl
    
        );
    
    };
    
    const closeReceipt = () =>

        setReceiptImage(null);

    const handleEdit = (expense) => {
    
        navigate(
    
            `/edit-expense/${expense.id}`
    
        );
    
    };
    
    const handleDelete = (expense) => {
    
        setSelectedExpense(expense);
    
        setDeleteDialogOpen(true);
    
    };

    const closeDeleteDialog = () => {

        setDeleteDialogOpen(false);
    
        setSelectedExpense(null);
    
    };

    const confirmDelete = async () => {

        if (!selectedExpense) {
    
            return;
    
        }
    
        try {
    
            setDeleting(true);
    
            await expenseService.deleteExpense(
    
                selectedExpense.id
    
            );
    
            notify.success(
    
                "هزینه حذف شد."
    
            );
    
            closeDeleteDialog();
    
            refresh();
    
        }
    
        catch (error) {
    
            console.error(error);
    
            notify.error(error);
    
        }
    
        finally {
    
            setDeleting(false);
    
        }
    
    };

    if (loading) {

        return <Loading />;

    }

    if (error) {

        return (

            <EmptyState

                title="خطا در دریافت اطلاعات"

                description="دریافت لیست هزینه‌ها با مشکل مواجه شد."

                buttonText="تلاش مجدد"

                onClick={refresh}

            />

        );

    }

    if (expenses.length === 0) {

        return (

            <>

                <ExpenseFilterBar

                    cars={cars}

                    categories={categories}

                    filters={filters}

                    onChange={updateFilters}

                    search={search}

                    setSearch={setSearch}

                    activeFilterCount={activeFilterCount}

                />

                <EmptyState

                    title="هنوز هزینه‌ای ثبت نشده است"

                    description="اولین هزینه خودرو را ثبت کنید."

                    buttonText="ثبت هزینه"

                    onClick={handleAddExpense}

                />

                {/* <FloatingActionButton

                    onClick={handleAddExpense}

                /> */}

            </>

        );

    }

    return (

        <>

            <ExpenseSummaryBar

                totalCount={summary.totalCount}

                totalAmount={summary.totalAmount}

                activeFilterCount={activeFilterCount}

            />

            <ExpenseFilterBar

                cars={cars}

                categories={categories}

                filters={filters}

                onChange={updateFilters}

                search={search}

                setSearch={setSearch}

                activeFilterCount={activeFilterCount}

            />

            <div className={styles.container}>

                {

                    expenses.map(expense => (

                        <ExpenseCard

                            key={expense.id}
                
                            expense={expense}
                
                            actions={{
                
                                onReceipt: handleReceipt,
                
                                onEdit: handleEdit,
                
                                onDelete: handleDelete,
                
                            }}
                
                        />

                    ))

                }

                {

                    hasMore &&

                    <div

                        ref={loadMoreRef}

                        className={styles.loadMore}

                    >

                        {

                            loadingMore &&

                            <Loading

                                text="در حال دریافت..."

                            />

                        }

                    </div>

                }

            </div>

            {/* <FloatingActionButton

                onClick={handleAddExpense}

            /> */}

            <ReceiptDialog

                open={Boolean(receiptImage)}

                receiptUrl={receiptImage}

                title="فاکتور هزینه"

                onClose={closeReceipt}

            />

            <ConfirmDialog

                open={deleteDialogOpen}

                title="حذف هزینه"

                message={`آیا از حذف هزینه "${selectedExpense?.category_title ?? ""}" در خودرو "${selectedExpense?.car_title ?? ""}" در تاریخ "${selectedExpense?.operDonDateP ?? ""}" مطمئن هستید؟`}

                loading={deleting}

                confirmText="حذف"

                cancelText="انصراف"

                onConfirm={confirmDelete}

                onCancel={closeDeleteDialog}

            />

        </>

    );

};

export default ExpenseList;